module.exports = __webpack_public_path__ + "img/detail-popup.0f381558.png";